// extracted by mini-css-extract-plugin
export default {"Content":"Layout_Content__+dVN8","LogoContainer":"Layout_LogoContainer__aOGY7"};